/* global $:false */

export default class Popup {
  static init () {
    Array.from($('.js-popup')).map((el) =>
      new Popup(el))
  }

  constructor (el) {
    this.showPopup = this.showPopup.bind(this)
    this.closePopup = this.closePopup.bind(this)
    this.el = $(el)
    this.findElements()
    this.readDataAttributes()
    this.setupBindings()
    if (this.el.hasClass('qa-skip-popup')) { this.closePopup() }
  }

  findElements () {
    this.closeButton = this.el.find('.js-popup__close')
  }

  readDataAttributes () {
    this.name = this.el.data('popup-name')
    this.alreadyClosed = window.localStorage['popup-closed-' + this.name]
    if (!this.alreadyClosed) {
      this.showPopup()
    } else { 
      this.el.css('display','none')
    }
  }

  setupBindings () {
    this.closeButton.click(event => {
      event.preventDefault()
      this.closePopup()
    })
  }

  showPopup () {
    window.addEventListener("load", event => {
      var image = document.querySelector('.js-popup__background-image');
      var isLoaded = image.complete && image.naturalHeight !== 0;
      this.el.css('visibility', 'visible');
    });
  }

  closePopup () {
    window.localStorage['popup-closed-' + this.name] = true
    this.el.css('display','none')
    this.el.hide()
  }
}
